import { render } from "./ProfileCryptosV1.1.vue?vue&type=template&id=c45e8ac6&scoped=true"
import script from "./ProfileCryptosV1.1.vue?vue&type=script&lang=js"
export * from "./ProfileCryptosV1.1.vue?vue&type=script&lang=js"

import "./ProfileCryptosV1.1.vue?vue&type=style&index=0&id=c45e8ac6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c45e8ac6"]])

export default __exports__